import { CSSProperties } from "react";
import { Divider as DividerRs } from "rsuite";

type DividerProps = {
  vertical?: boolean;
  margin?: number;
  style?: CSSProperties;
};

const Divider = ({ vertical = false, margin = 14, style }: DividerProps) => {
  return (
    <DividerRs
      vertical={vertical}
      style={{ marginBlock: margin, color: "#BFBFBF", ...style }}
    />
  );
};
export default Divider;
